import React from 'react';
import PropTypes from 'prop-types';

const AdminReportsDataListItemGeneral = ({
  index,
  item,
}) => {
  let responseItem = item[index];

  if (!responseItem) {
    responseItem = item;
    if (typeof responseItem === 'object') {
      responseItem = '';
    }
  }

  return (
    <td>
      {responseItem}
    </td>
  );
};

AdminReportsDataListItemGeneral.propTypes = {
  index: PropTypes.string.isRequired,
  item: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object]),
};

AdminReportsDataListItemGeneral.defaultProps = {
  item: {},
};

export default AdminReportsDataListItemGeneral;
